import React from "react";
import { useTable, useColumnOrder } from "react-table";

export default function Table1({ data }) {
  const columns = React.useMemo(
    () => [
      {
        Header: "CFTC Net Non-Commercial Futures & Options Contract",
        columns: [
          {
            Header: "Asset Class",
            accessor: "assetClass",
          },
          {
            Header: "Market",
            accessor: "market",
          },
          {
            Header: "Current Contract Positioning",
            accessor: "currentPositioning",
          },
          {
            Header: "W/W / CHG",
            accessor: "wwchg",
          },
          {
            Header: "M/M / CHG",
            accessor: "mmchg",
          },
          {
            Header: "3M / AVG",
            accessor: "threeMchg",
          },
          {
            Header: "6M / AVG",
            accessor: "sixMchg",
          },
          {
            Header: "1Y / AVG",
            accessor: "oneYchg",
          },
          {
            Header: "3Y / Min",
            accessor: "min",
          },
          {
            Header: "3Y / Max",
            accessor: "max",
          },
        ],
      },
    ],
    [],
  );

  const { getTableProps, getTableBodyProps, headerGroups, rows, prepareRow } =
    useTable({ columns, data }, useColumnOrder);

  function cellStyle(cell, i) {
    if (i === 0) {
      return {
        position: "relative",
        left: 22,
        textAlign: "left",
      };
    }

    if (i === 1) {
      return {
        display: "flex",
        justifyContent: "flex-start",
        width: 160,
        marginRight: -60,
      };
    }

    if (i > 1) {
      if (i === 10) {
        if (cell.value > 1)
          return { background: "#000000", borderLeft: "1px solid #666666" };
        if (cell.value < 0)
          return { background: "#D33541", borderLeft: "1px solid #666666" };
        return { color: "white", borderLeft: "1px solid #666666" };
      }
      if (i === 11) {
        if (cell.value > 1) return { background: "#000000" };
        if (cell.value < 0) return { background: "#D33541" };
        return { color: "white" };
      }
      if (cell.value > 0) {
        return { color: "#5EC72E" };
      } else {
        return { color: "#D33541" };
      }
    }
    // else {
    //   return { justifyContent: "start", display: "flex" }
    // }
  }

  function formatHeader(column, i) {
    const result = column.Header.split(" / ");
    if (i === 0) {
      return (
        <div
          style={{
            padding: "20px",
            display: "flex",
            justifyContent: "flex-start",
          }}
        >
          {result[0]}
          <div
            style={{ marginTop: 6 }}
            data-tip={`The # of futures and options contracts that are net long (green) and net short (red).`}
            className="info-icon"
          >
            i
          </div>
        </div>
      );
    }

    if (result[0] === "Asset Class")
      return (
        <div style={{ position: "relative", left: 22, textAlign: "left" }}>
          <div>
            <div>{result[0]}</div>
            <div>{result[1]}</div>
          </div>
        </div>
      );

    if (result[0] === "Market")
      return (
        <div style={{ textAlign: "left" }}>
          <div>
            <div>{result[0]}</div>
            <div>{result[1]}</div>
          </div>
        </div>
      );

    if (result[0] === "Current Positioning")
      return (
        <div>
          <div style={{ display: "flex", justifyContent: "center" }}>
            <div>{result[0]}</div>
            <div>{result[1]}</div>
            <div
              style={{ marginTop: 1 }}
              data-tip={`The latest value of positioning from the CFTC.`}
              className="info-icon"
            >
              i
            </div>
          </div>
        </div>
      );

    return (
      <div style={{}}>
        <div>
          <div>{result[0]}</div>
          <div>{result[1]}</div>
        </div>
      </div>
    );
  }

  function formatCurrency(cell, i) {
    function numberWithCommas(x) {
      return x.toLocaleString("en-US", {
        maximumFractionDigits: 0,
        minimumFractionDigits: 0,
      });
    }
    if (i === 10 || i === 11) {
      if (cell.value) {
        const curr = cell.value.toLocaleString("en-US", {
          maximumFractionDigits: 3,
          minimumFractionDigits: 3,
        });
        return curr;
      }
    }
    if (i > 1 && i < 10) {
      if (cell.value) {
        const curr = numberWithCommas(cell.value);
        return curr;
      }
    }
    if (cell.value === "FIXED INCOME") {
      return (
        <div style={{ marginBottom: -20 }}>
          <div>FIXED</div>
          <div>INCOME</div>
        </div>
      );
    }
    if (cell.value === "30Yr UST (Long + Ultra Long)") {
      return "30Yr UST (Long+Ultra Long)";
    }
    return cell.value;
  }

  return (
    <table {...getTableProps()}>
      <thead>
        {headerGroups.map((headerGroup, i) => {
          return (
            <tr
              className={i === 1 ? "border-bottom" : ""}
              {...headerGroup.getHeaderGroupProps()}
            >
              {headerGroup.headers.map((column) => (
                <th {...column.getHeaderProps()}>{formatHeader(column, i)}</th>
              ))}
            </tr>
          );
        })}
      </thead>
      <tbody {...getTableBodyProps()}>
        {rows.map((row, id) => {
          prepareRow(row);
          return (
            <tr {...row.getRowProps()}>
              {row.cells.map((cell, i) => {
                return (
                  <td style={cellStyle(cell, i)} {...cell.getCellProps()}>
                    {formatCurrency(cell, i)}
                    {i === 1 ? (
                      <div
                        data-tip={data[id].ticker}
                        className="info-icon"
                        style={{
                          marginLeft: 6,
                          marginTop: 2,
                        }}
                      >
                        i
                      </div>
                    ) : (
                      <div></div>
                    )}
                  </td>
                );
              })}
            </tr>
          );
        })}
      </tbody>
    </table>
  );
}
